import { ProjectGlobalConversation } from 'api/project-conversations';
import { PinScopeType } from 'api/spotlight/types';
import { unreachable } from 'utils/unreachable';

export const pinScopeTypeFromProjectConversation = (
  conversation: ProjectGlobalConversation,
): PinScopeType => {
  const { displayEntityType } = conversation;

  switch (displayEntityType) {
    case 'tasks':
      return PinScopeType.Task;
    case 'space-tabs':
      return PinScopeType.Document;
    case 'status-updates':
      return PinScopeType.StatusUpdate;
    default:
      return unreachable(displayEntityType);
  }
};
export const scopeIdFromProjectConversation = (
  conversation: ProjectGlobalConversation,
): number | undefined => {
  const { displayEntityType } = conversation;

  switch (displayEntityType) {
    case 'tasks':
    case 'space-tabs':
      return conversation.entityId;
    case 'status-updates':
      return conversation.statusUpdate?.statusUpdateId;
    default:
      return unreachable(displayEntityType);
  }
};
